import { computed } from 'vue';
import { enUS, nl } from 'date-fns/locale';
import { useTranslation } from 'i18next-vue'
import { storeToRefs } from 'pinia';

import { Language } from 'src/types/language';
import { useUserStore } from 'src/stores/user-store';

interface Translations {
  nl: Record<string, string>;
  en: Record<string, string>;
}

export function useLanguage (translations?: Translations) {
  const userStore = useUserStore();
  const { config } = storeToRefs(userStore);
  const { t, i18next } = useTranslation();

  if (translations) {
    Object.entries(translations).forEach(([lang, values]) => {
      i18next.addResourceBundle(lang, 'translation', values);
    });
  }

  const dateFnsLocale = computed(() => {
    if (config.value.language === Language.DUTCH) {
      return nl;
    }

    return enUS;
  });

  function setLanguage (lang: Language) {
    userStore.updateLanguage(lang);

    document.documentElement.lang = lang;
    i18next.changeLanguage(lang);
  }

  function translate (key: string): string {
    return t(key);
  }

  return {
    language: computed(() => config.value.language),
    setLanguage,
    dateFnsLocale,
    translate,
  };
}
